import useStore from './_store';
import { mapState, mapActions } from '@/store/helpers';

import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
import * as TYPES from './_store/types';
import util from '@/common/utils/util-tool';
import { NBR_NUM_TYPE } from '@/common/constants/area-types';
import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-featured-area'
    },
    mixins: [spaceMixin(), colorMixin()],
    asyncData: mapAsyncData(asyncData),
    data: function() {
        let config = {
            theme: '', // style
            title: '', // title
            ids: '', //nbr and non neighborhood
            bgType: '', // background type  img / color
            bgImgOpt: {
                src: '',
                mobileSrc: ''
            }, // Background picture
            bgColor: '', // background color
            maskOption: {
                showMask: true,
                maskColor: 'rgba(25,25,25,0.3)'
            },
            more: {
                text: '',
                link: '',
                target: '_blank'
            },
            defaultImgSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/default-img.png',
        };
        return {
            ...config,
            defaultImgs: [
                '//cdn.chime.me/image/fs01/sitebuild/20181010/0/original_24134616374507202.jpeg',
                '//cdn.chime.me/image/fs/sitebuild/2019111/23/original_2fb3bd8e-5c31-4896-bad8-e3dddb324ab7.png',
                '//cdn.chime.me/image/fs/sitebuild/2019111/23/original_d86101f9-c788-4bc5-85bc-b9b009885852.png',
                '//cdn.chime.me/image/fs/sitebuild/2019111/23/original_53cf6605-a7ca-48f6-bd02-3e146ac82d53.png',
                '//cdn.chime.me/image/fs/sitebuild/2019111/23/original_6175b863-1204-4055-92bf-7b353dba4e06.png',
                '//cdn.chime.me/image/fs/sitebuild/2019111/23/original_bec42379-a6ca-4b79-acc5-af5e8945132e.png'
            ]
        };
    },
    computed: {
        ...mapState({
            list: 'list'
        }),

        suitableImg() {
            if (this.isMobileSize && this.bgImgOpt.mobileSrc) {
                return this.bgImgOpt.mobileSrc; 
            }
            return this.bgImgOpt.src || this.bgImgOpt.mobileSrc;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        textAnimation() {
            return {
                name: this.align == 'right' ? 'shift-left' : 'shift-right',
                enable: this.showAnimationEffects
            }
        },
        moreButtonText() {
            return util.isEmptyRichtext(this.more?.text) ? this.$t('md-featured-area.showMore') : this.more?.text;
        },
        moreButtonLink() {
            return this.more?.link ?? "";
        },
        showMoreButton() {
            const link = this.moreButtonLink.trim().replace(/^\/+/, '');
            return this.showMore && this.moreButtonText && !!link;
        },
        moreButtonTarget() {
            return this.more?.target ?? "_blank";
        },
    },
    methods: {
        ...mapActions({
            getData: TYPES.FETCH_NBR_LIST
        }),
        isCityType(nbr) {
            return [NBR_NUM_TYPE.city].includes(nbr.type);
        },
    }
};
